var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEatExpFilled = function SvgEatExpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "#827127",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37 1.002a1 1 0 0 1 .935 1.06l-.3 4.813A2 2 0 0 0 6 9h.613a2 2 0 0 0 1.997-2.125L8.31 2.062a1 1 0 0 1 1.996-.124l.301 4.812a4 4 0 0 1-3.3 4.19V20a1 1 0 0 1-2 0v-9.06a4 4 0 0 1-3.3-4.19l.302-4.812a1 1 0 0 1 1.06-.936"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.308 1a1 1 0 0 1 1 1v4.5a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1M20 2a1 1 0 0 0-1.448-.894 10.8 10.8 0 0 0-3.191 2.46c-.924 1.048-1.673 2.353-1.855 3.81-.302 2.421-.425 4.166-.474 5.59-.05 1.412 1.09 2.534 2.467 2.534H18V20A1 1 0 0 0 20 20z"
  })));
};
export default SvgEatExpFilled;